/* @ngInject */
// class configHttp {
//   constructor($httpProvider) {
//     $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
//     $httpProvider.defaults.withCredentials = true;
//     $httpProvider.interceptors.push('HttpInterceptorFactory');
//   }
// }

// export default['$httpProvider', configHttp];


// angular
// .module("HeroPRO")
// .config(configHTTP);

/* @ngInject */
export default function configHTTP($httpProvider) {
    // HTTP defaults
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.interceptors.push('HttpInterceptorFactory');
}



// WEBPACK FOOTER //
// ./src/app/config/app.http.config.js